import { useEffect } from 'react'

export const useOnEscClose = ({ onClose }) => {
  useEffect(() => {
    const onKeyDown = e => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [ onClose ])
}
